import ProfileHeroFTUE from './ProfileHeroFTUE';
import ProfileHeroFTUEContainer from './ProfileHeroFTUE.container';
export default ProfileHeroFTUEContainer(ProfileHeroFTUE);
